export enum MultiFactorAuthView {
	PHONE = 'PHONE',
	TOKEN = 'TOKEN',
	PASSWORD = 'PASSWORD'
}
